import { jsonComparer, useMessageToState } from "./useMessageToState";

function getCalendarDataSourcesFromDefinition({ definition }: eXpress.core.IEditor) {
	if (!definition) {
		return undefined;
	}

	const { UserDate: personalEvents, ...specialDays } =
		eXpress.creator.calendars.calendarUtils.getCalendarDataSources(definition);

	return {
		personalEvents,
		specialDays,
	} as const;
}

export function useCalendarDataSources() {
	return useMessageToState({
		name: "useCalendarDataSources",
		getState: getCalendarDataSourcesFromDefinition,
		filterMessage: (m) => {
			return m instanceof eXpress.creator.calendars.CalendarDataSourcesChangedMessage;
		},
		comparer: jsonComparer,
	});
}
